import React from "react";
import addLinkVisual from "../../assets/visuals/add-link.svg";
import { Modal, Button } from "antd";

const ModalLinkCopied = ({ modalIsOpen, setModalIsOpen }) => {
  return (
    <Modal
      title="Ajoutez votre lien dans votre bio"
      className="modal-link-copied"
      closable={false}
      visible={modalIsOpen}
      footer={null}
      onOk={() => {
        setModalIsOpen(false);
      }}
      onCancel={() => {
        setModalIsOpen(false);
      }}
    >
      <div className="">
        <b>Votre lien a été copié dans le presse-papier</b>
        <span role="img" aria-label="emoji">
          🎉
        </span>
        .
      </div>
      <div style={{ fontStyle: "italic" }}>Et maintenant ? </div>
      <div style={{ marginTop: "10px" }}>
        <b>Ajoutez votre lien Linksight dans votre bio</b> pour ramener du
        traffic sur votre page.
      </div>
      <div className="visual-link">
        <img src={addLinkVisual} alt="link visual" width="70%" />
      </div>

      <Button
        className="submit-link"
        htmlType="submit"
        size="large"
        onClick={() => setModalIsOpen(false)}
      >
        J'ai compris
      </Button>
    </Modal>
  );
};

export default ModalLinkCopied;
